export default "__VITE_ASSET__BhubZOSk__"